export const categoryPillSx = (selected, { readOnly = false } = {}) => ({
  border: '1px solid',
  borderColor: selected ? '#95F205' : 'grey',
  bgcolor: selected ? 'rgba(149, 242, 5, 0.16)' : '#21232D',
  color: selected ? '#95F205' : '#fff',
  borderRadius: '999px',
  px: 1.5,
  py: 0.65,
  minWidth: 'auto',
  fontSize: 12,
  fontWeight: selected ? 700 : 500,
  lineHeight: 1.2,
  textTransform: 'capitalize',
  fontFamily: 'inherit',
  boxShadow: 'none',
  outline: 'none',
  appearance: 'none',
  WebkitTapHighlightColor: 'transparent',
  cursor: readOnly ? 'default' : 'pointer',
  transition: 'border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease',
  '&::-moz-focus-inner': {
    border: 0,
  },
  '&:hover:not(:disabled)': {
    borderColor: '#95F205',
    bgcolor: selected ? 'rgba(149, 242, 5, 0.22)' : 'rgba(149, 242, 5, 0.08)',
  },
  '&:active:not(:disabled)': {
    borderColor: '#95F205',
    bgcolor: selected ? 'rgba(149, 242, 5, 0.22)' : 'rgba(149, 242, 5, 0.08)',
    boxShadow: 'none',
  },
  '&:focus': {
    outline: 'none',
  },
  '&:focus-visible': {
    outline: 'none',
    boxShadow: `0 0 0 2px ${selected ? 'rgba(149, 242, 5, 0.45)' : 'rgba(149, 242, 5, 0.3)'}`,
  },
  '&:disabled': {
    opacity: readOnly ? 1 : 0.5,
  },
});

export const categoryPillGroupSx = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 0.75,
};
